// Centralised data-testid catalogue for the flashcard app.
export const NAV = {
  studyLink: 'nav-study-link',
  addLink: 'nav-add-link',
  listLink: 'nav-list-link',
  dashboardLink: 'nav-dashboard-link',
  themeToggle: 'theme-toggle-btn',
};

export const ADD = {
  germanInput: 'add-german-input',
  typeSelect: 'add-type-select',
  submitBtn: 'add-submit-btn',
  bulkTextarea: 'add-bulk-textarea',
  bulkSubmitBtn: 'add-bulk-submit-btn',
  feedback: 'add-feedback',
};

export const STUDY = {
  modeDeTr: 'mode-de-tr-btn',
  modeTrDe: 'mode-tr-de-btn',
  startBtn: 'study-start-btn',
  card: 'study-flashcard',
  flipBtn: 'study-flip-btn',
  learnedBtn: 'study-learned-btn',
  reviewBtn: 'study-review-btn',
  unknownBtn: 'study-unknown-btn',
  newBtn: 'study-new-btn',
  // Legacy aliases kept for backwards-compat with older tests
  knowBtn: 'study-learned-btn',
  dontKnowBtn: 'study-unknown-btn',
  nextBtn: 'study-next-btn',
  resetBtn: 'study-reset-btn',
  progressBar: 'study-progress-bar',
  emptyState: 'study-empty-state',
  finishedState: 'study-finished-state',
  reloadSeedBtn: 'study-reload-seed-btn',
};

export const LIST = {
  table: 'word-list-table',
  row: (id) => `word-row-${id}`,
  deleteBtn: (id) => `word-delete-${id}`,
  editBtn: (id) => `word-edit-${id}`,
  searchInput: 'word-search-input',
  clearAllBtn: 'word-clear-all-btn',
};

export const DASH = {
  totalWords: 'dash-total-words',
  studiedSessions: 'dash-sessions',
  accuracy: 'dash-accuracy',
  knownCount: 'dash-known',
  learnedCount: 'dash-learned',
  reviewCount: 'dash-review',
  unknownCount: 'dash-unknown',
  newCount: 'dash-new',
  typeChart: 'dash-type-chart',
  historyChart: 'dash-history-chart',
  categoryChart: 'dash-category-chart',
};

// kept for backward compatibility with template
export const HOME = { emergentLink: 'home-emergent-link' };
